require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./winpereport-wlsa.json") })
        }
      }, "path---winpereport-wlsa");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---winpereport-wlsa!./.cache/json/winpereport-wlsa.json
// module id = 1283
// module chunks = 231608221292675